import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, Activity, ActivityResponse } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { ActivityService} from '../service/activity.service';
import { AppConstants } from '../core/app.constants';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-daily-activity',
  templateUrl: './daily-activity.component.html',
  styleUrls: ['./daily-activity.component.css']
})
export class DailyActivityComponent extends BaseComponent implements OnInit
{
    @Input() targetdate: Date = null;
    @Input() refresh: Subject<boolean>;
    completed: boolean = false;
    totalTime: string = null;
    activities: Activity[] = new Array();
    userContext: UserContext = null; 
    showDeleteAlert: boolean = false;
    currentActivity: Activity = null;
    @Output() onDelete = new EventEmitter<boolean>();

    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private activityService: ActivityService)  
    {
        super(authAccess, router, messageProvider);
    }

  ngOnInit() 
  {
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext != null)
      {
          if(this.targetdate == null || typeof(this.targetdate) == 'undefined') {
              this.targetdate = new Date();
          }
          this.refresh.asObservable().subscribe(value => { this.load(); });
          this.load();
      }
      else {
          this.authAccess.invalidate();
      }
  }
  
  private load()
  {
      var response: ActivityResponse;
      this.activityService.search(this.userContext.srmToken, this.targetdate, this.targetdate, null, null).
      subscribe(
           result => {
               this.completed = true;
               response = result;
               this.activities = response.activities;
               this.totalTime = AppConstants.formatDuration(response.totalHours, response.totalMinutes); 
           },
           error => {
               this.completed = true;
               this.handleError(error);
           });
  }
  
  deleteActivity()
  {
      if(this.currentActivity == null) {
          // non dovrebbe mai verificarsi
          alert("Nessuna attività da eliminare!");
          return;
      }
      this.activityService.deleteActivity(this.userContext.srmToken, this.currentActivity.id, this.currentActivity.issueId).
           subscribe( 
              result => {
                  this.messageProvider.notifyMessage("Attività eliminata correttamente");
                  this.currentActivity = null;
                  this.onDelete.emit(true);
              }, 
              error  => {
                  this.handleError(error);
              });
  }
  
  openDeleteAlert(currentActivity) {
      this.currentActivity = currentActivity;
      this.showDeleteAlert = true;      
  }
  closeDeleteAlert() {
      this.showDeleteAlert = false;      
  }
  
  openDetail(activity: Activity) {
      if(activity == null) {
          activity = new Activity();
      }
      this.activityService.openActivityDetail(activity);
  }
}



// WEBPACK FOOTER //
// ./src/app/daily-activity/daily-activity.component.ts